import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { ErrorBox } from '@/components/commons/error-box'
import { AlertTriangleIcon } from '@/components/ui/icons'
import { ErrorBoundary } from '@/error-boundary'
import { OpsVettingURLParams } from '@/features/ops-vetting/types'
import { useGetServiceProPhotos } from '@/features/service-vetting/query/use-get-service-pro-photo'
import { useURLParsedParams } from '@/hooks/use-url-parsed-params'
import { useTranslation } from '@/translations/i18n'

export const ServiceProPhotosRoute = () => {
	const { t } = useTranslation()
	const urlParams = useURLParsedParams(OpsVettingURLParams)

	return urlParams.success ? (
		<ProPhotosDataInitializer serviceId={urlParams.data.id}>
			<ErrorBoundary>
				<Outlet context={{ urlParams: urlParams.data }} />
			</ErrorBoundary>
		</ProPhotosDataInitializer>
	) : (
		<ErrorBox
			icon={<AlertTriangleIcon />}
			title={t('errors:invalid_url')}
		/>
	)
}
ServiceProPhotosRoute.displayName = 'ServiceProPhotosRoute'

export const ProPhotosDataInitializer = ({
	serviceId,
	children
}: {
	serviceId: OpsVettingURLParams['id']
	children: ReactNode
}) => {
	useGetServiceProPhotos(serviceId)
	return children
}
